"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pretty_bytes_1 = __importDefault(require("pretty-bytes"));
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const Audiences_1 = require("../../common/js/constants/Audiences");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const DataLayerEvents_1 = __importDefault(require("../enums/DataLayerEvents"));
const DataLayerLabels_1 = __importDefault(require("../enums/DataLayerLabels"));
const dataLayer_1 = require("../helper/dataLayer");
const DownloadTile = (props) => {
    const { file, software, category } = props;
    const options = {
        audience: Audiences_1.Audiences.DOWNLOADS,
        ignoreCache: false,
        scope: [AuthorizationScopes_1.default.DOWNLOADS_READ, 'email'].join(' '),
    };
    return (react_1.default.createElement("div", { className: "znd-download-tile col-md-6", onClick: () => {
            AuthorizationStore_1.default.auth0?.getAccessTokenSilently(options).then((accessToken) => {
                const url = new URL(`https://${__APP__.DOWNLOADS_HOST}/api/v1/software/${software}/${category}/${file.key}`);
                url.searchParams.set('bearer', accessToken);
                window.open(url, '_blank');
            });
            (0, dataLayer_1.pushToDataLayer)({
                event: DataLayerEvents_1.default.dlvDownloads,
                [DataLayerLabels_1.default.dlvDownload]: file.name,
            });
        } },
        react_1.default.createElement("div", { className: "znd-download-tile__inner" },
            react_1.default.createElement("div", { className: "znd-download-tile__detail" },
                react_1.default.createElement("div", { className: "znd-download-tile__title t-subhead-1" }, file.name),
                react_1.default.createElement("div", { className: "znd-download-tile__info" },
                    !!file.extension ? file.extension.toUpperCase() + ' • ' : null,
                    (0, pretty_bytes_1.default)(file.size))),
            react_1.default.createElement(Icon_1.default, { className: "znd-download-tile__icon", name: Zupicons_1.default.download }))));
};
exports.default = DownloadTile;
